import React from "react";

class ForumTitleField extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="form-field">
                <label>
                    <h3>Title</h3>
                    <textarea
                        row={2}
                        cols={60}
                        value={this.props.value}
                        onChange={this.props.onChange}
                    />
                </label>
            </div>
        )
    }
}

export default ForumTitleField;
